module.exports = "/_next/static/images/DevelopOnSegment-b3c0d55e7b6ca5c0f46304d63158d446.webp";